import { connect } from 'react-redux'
import { compose } from 'recompose'
import { withTranslation } from 'react-i18next'
import { removeContent } from '../../../../store/actions/blocks'

export const ImageBlockOptionsContainer = compose(
  connect(
    null,
    (dispatch, { block }) => ({
      removeContent: () => dispatch(removeContent([block]))
    })
  ),
  withTranslation()
)

export default ImageBlockOptionsContainer
